import RadioGroup, {RadioGroupProps} from '@mui/material/RadioGroup';
import Radio, {RadioProps} from '@mui/material/Radio';
import {styled} from '@mui/material/styles';

export const CRadioGroup = styled(RadioGroup)<RadioGroupProps>(
  (/* { theme } */) => ({
  }),
);


export const CRadio = styled(Radio)<RadioProps>(
  (/* { theme } */) => ({
  }),
);
